import { isEqual } from "lodash-es";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import {
    PageTemplates,
    isPageTemplate,
} from "@utils/configuration/pageTemplate.helpers";
import { useAlgoliaParameters } from "@utils/hooks/algolia/useAlgoliaParameters.hook";
import { SearchComponents } from "@utils/search/@types/searchComponent";
import { configurationFromUrl } from "@utils/search/routing/configurationFromUrl";
import {
    configurationToUrl,
    updateWindowTitleByConfiguration,
} from "@utils/search/routing/configurationToUrl";

import { useThunkDispatch } from "@redux/dispatcher";
import { configureSearch } from "@redux/modules/value/search/search.actions";
import {
    getSearchConfiguration,
    hasComponentResults,
} from "@redux/modules/value/search/search.selectors";

const useSearchRouting = (ignoreQuery: boolean) => {
    const dispatch = useThunkDispatch();
    const configuration = useSelector(getSearchConfiguration, isEqual);
    const results = useSelector(hasComponentResults);
    const algoliaParameters = useAlgoliaParameters();

    const isSearchPageTemplate = isPageTemplate(PageTemplates.SEARCH);

    useEffect(() => {
        const handleNavigate = () =>
            dispatch(
                configureSearch(configurationFromUrl(ignoreQuery), {
                    configuration: [],
                    state: SearchComponents.ALL,
                }),
            );

        handleNavigate();
        window.addEventListener("popstate", handleNavigate);
        return () => {
            window.removeEventListener("popstate", handleNavigate);
        };
    }, [algoliaParameters]);

    useEffect(() => {
        if (!configuration) return;
        if (!results) return;

        const url = configurationToUrl(configuration, ignoreQuery);
        if (isSearchPageTemplate) {
            updateWindowTitleByConfiguration(configuration);
        }

        if (url === location.href) return;

        history.pushState({}, "", url);
    }, [configuration]);
};

export { useSearchRouting };
